import getOr from 'lodash/fp/getOr';

import { isMobile } from "./utils";
import { getCookie, getGaClientId } from "./browser";
import { Auth } from '../models/auth';
import { LocalStorage } from '../models/LocalStorage';
import { FireBase } from './firebase';
import { ROOT_GLOBAL } from '../global/root';
import Env from '../environments';
import { GLOBAL_CONSTANTS } from '../global/constants';
import { Category } from '../models/Category';
import { Blog } from '../models/Blog';
import { Paging } from '../models/Paging';
import { genEndPointGetParam, getParamUrl } from './url';
import { Comment } from '../models/Comment';
import { getCookieUtmParams } from './script';
import { setAppToken } from './miniApp';

const queryString = require('query-string');
const endPointDutycastB2C = Env.DUTY_CAST_EXTENSION_API;
const endPointSearchDutycastB2C = Env.DUTY_CAST_EXTENSION_SEARCH_API;

export function genHeaderApi(isFormData = false, isBearer = false, isNoToken = false, noCache = false) {
  const token = LocalStorage.getUserToken();
  const clientId = getGaClientId();
  const currency = LocalStorage.getCurrency();
  const userId = LocalStorage.getUserId();
  // const location = getCurrentCountry();
  const requestId = getCookie(GLOBAL_CONSTANTS.COOKIE.FOEID);
  const tf = getCookie(GLOBAL_CONSTANTS.COOKIE.TF);
  const tfid = getCookie(GLOBAL_CONSTANTS.COOKIE.TFID);
  const platform = getCookie(GLOBAL_CONSTANTS.COOKIE.PLATFORM) || (isMobile() ? "mobile-web" : "web");
  const firebaseToken = getCookie(GLOBAL_CONSTANTS.COOKIE.FIREBASE_TOKEN);
  const nid = getCookie(GLOBAL_CONSTANTS.COOKIE.NOTIFICATION_ID);
  const neq = getCookie(GLOBAL_CONSTANTS.COOKIE.NEQ);
  const result = {
    "App-Platform": platform,
    "App-Local-Timestamp": Date.now(),
    "App-Uuid": clientId,
    "App-Currency": currency,
    "App-tf": tf,
    "App-tfid": tfid,
    "App-referrer": document.referrer
  }

  result["App-Locale"] = LocalStorage.getLanguage() || "";

  const rc = getParamUrl("rc");
  if (rc) {
    result["App-Referral-Code"] = rc;
  }

  if (LocalStorage.getBilling()) {
    result["App-Billing-Country"] = LocalStorage.getBilling();
  }

  if (LocalStorage.getShipping()) {
    result["App-Shipping-Country"] = LocalStorage.getShipping();
  }

  if (firebaseToken) {
    result["App-ft"] = firebaseToken;
  }

  if (nid) {
    result["App-nid"] = nid;
  }

  if (neq) {
    result["App-neq"] = neq;
  }

  var uid = getParamUrl("uid") || getCookie(GLOBAL_CONSTANTS.UID);
  if (uid) {
    result["App-Uid"] = uid;
  }
  const version = getCookie(GLOBAL_CONSTANTS.COOKIE.VERSION) || Env.DUTY_CAST_BUILD_APP_VERSION;
  if (version) {
    result["App-Version"] = version;
  }

  if (requestId) {
    result["App-Req-Id"] = requestId;
  }

  if (!isFormData) {
    result["Content-Type"] = "application/json";
  }

  if (!!token && !isNoToken) {
    result["Authorization"] = isBearer ? "Bearer " + token : token;
  }

  if (!!userId) {
    result["App-Id"] = userId;
  }

  if (noCache) {
    result['cache-control'] = 'no-cache';
    result['pragma'] = 'no-cache';
  }
  return result;
}

export function callApi(url, data, type = "POST", headers = {}, successCallBack, errorCallBack, isFormData = false, isRemoveParams = false) {
  if (!url) {
    return;
  }
  const cookieParam = getCookieUtmParams();

  let urlApi = "";

  const parseUrl = queryString.parseUrl(url);

  if (isRemoveParams) {
    urlApi = parseUrl.url;
  } else {
    let param = getParamUrl();
    param = { ...cookieParam, ...param, ...parseUrl.query };
    urlApi = genEndPointGetParam(parseUrl.url, param);
  }

  return new Promise((resolve, reject) => {
    window.$.ajax({
      url: urlApi,
      type: type,
      dataType: isFormData ? undefined : 'json',
      headers: headers,
      processData: false,
      contentType: isFormData ? false : 'application/json',
      success: async function (data) {
        if (typeof successCallBack === "function") {
          try {
            await successCallBack(data);
          } catch (error) {
            console.error(error);
          }
        } else {
          console.log(data);
        }
        resolve(data);
      },
      error: function (xhr, status, error) {
        try {
          const errorObj = JSON.parse(xhr.responseText);
          const errorCode = getOr('', 'error_code')(errorObj);
          if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.EXPIRE_TOKEN) {
            apiRefreshToken((newToken) => callApi(url, data, type, updateHeaderToken(headers, newToken), async (data) => {
              if (typeof successCallBack === "function") {
                try {
                  await successCallBack(data);
                } catch (error) {
                  console.error(error);
                }
              } else {
                console.log(data);
              }
              resolve(data);
            }, errorCallBack, isFormData)).catch(reject);
            return;
          }
          if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.INVALID_TOKEN && !LocalStorage.isMiniApp()) {
            FireBase.signOut(undefined, undefined, Auth.callBackLogin(), false);
          }
          if (typeof errorCallBack === "function") {
            errorCallBack(errorObj);
          } else {
            console.error(errorObj);
          }
        } catch (error) {
          if (typeof errorCallBack === "function") {
            errorCallBack(xhr.responseText);
          } else {
            console.error(xhr.responseText);
          }
        }
        reject(xhr);
      },
      data: isFormData ? data : JSON.stringify(data)
    });
  });
}

function updateHeaderToken(header, newToken) {
  const result = {
    ...header
  }
  if (header && typeof header === "object" && header["Authorization"]) {
    const token = newToken ?? LocalStorage.getUserToken();
    result["Authorization"] = header["Authorization"].indexOf("Bearer") !== -1 ? "Bearer " + token : token;
  }
  return result;
}

export function apiLogin(params, onSuccess, onError, apiTime) {
  return callApi(
    `${endPointDutycastB2C}/v1/login_with_phone`,
    { ...params, meta: getParamUrl() },
    "POST",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Auth.fromApiObject(data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      console.error(error);
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export const handleTokenError = () => {
  return FireBase.signOut(function () {
    window.location.href = `${ROOT_GLOBAL.LOGIN}&cb=${encodeURIComponent(window.location.href)}`
  }, function () {
    window.location.href = `${ROOT_GLOBAL.LOGIN}&cb=${encodeURIComponent(window.location.href)}`
  });
}

export function apiRefreshToken(callback) {
  return callApi(
    `${endPointDutycastB2C}/v1/refresh_token`,
    {
      "refresh_token": LocalStorage.getRefreshToken()
    },
    "POST",
    genHeaderApi(),
    function (data) {
      try {
        const result = Auth.fromApiObject(data);
        if (result.isVaildAuth()) {
          result.saveLoginInfo();
          LocalStorage.isMiniApp() && setAppToken(result.authToken);
          typeof (callback) === "function" && callback(result.authToken);
        } else {
          handleTokenError();
        }
      } catch (error) {
        console.error(error);
        handleTokenError(error);
      }
    },
    function (error) {
      console.error(error);
      handleTokenError(error);
    }
  );
}

export function apiLogout(onSuccess, onError, apiTime) {
  return callApi(
    `${endPointDutycastB2C}/v1/logout`,
    {},
    "POST",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess();
      }
    },
    function (error) {
      console.error(error);
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function apiGetCategories(onSuccess, onError, apiTime) {
  return callApi(endPointDutycastB2C + "/v1/blog_categories",
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Category.fromApiArray(data.data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetblogs(params, onSuccess, onError, apiTime) {
  let headers = genHeaderApi();
  return callApi(genEndPointGetParam(endPointDutycastB2C + "/v1/blogs", params),
    undefined,
    "GET", headers, function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Blog.fromApiArray(data.data);
          const paging = Paging.fromApiObject(data.paging);
          typeof (onSuccess) === "function" && onSuccess(result, paging);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetBlogDetail(id, onSuccess, onError, apiTime) {
  let headers = genHeaderApi();
  headers['App-Locale'] = "vi"
  return callApi(`${endPointDutycastB2C}/v1/blogs/${id}`,
    undefined,
    "GET", headers, function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Blog.fromApiObject(data.data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetblogRelative(id, onSuccess, onError, apiTime) {
  return callApi(`${endPointDutycastB2C}/v1/blogs/${id}/related`,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Blog.fromApiArray(data.data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetBlogComments(params, onSuccess, onError, apiTime) {
  return callApi(genEndPointGetParam(endPointDutycastB2C + "/v1/blog_article_comment", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Comment.fromApiArray(data.data);
          const paging = Paging.fromApiObject(data.paging);
          typeof (onSuccess) === "function" && onSuccess(result, paging);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}


export function apiCreateBlogComment(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + `/v1/blog_article_comment/`,
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        const result = Comment.fromApiObject(data.data);
        typeof (onSuccess) === "function" && onSuccess(result);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiUpdateBlogComment(id, params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + `/v1/blog_article_comment/${id}`,
    params,
    "PUT", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        const result = Comment.fromApiObject(data.data);
        typeof (onSuccess) === "function" && onSuccess(result);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiDeleteBlogComment(id, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + `/v1/blog_article_comment/${id}`,
    undefined,
    "DELETE", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiCreateCheckoutIntent(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/orders/payment_intent",
    params,
    "POST",
    genHeaderApi(),
    function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const chargeSecret = getOr({}, "data.charge_secret")(data);
          typeof (onSuccess) === "function" && onSuccess(chargeSecret);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    },
    function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
      }
    }
  );
}

export function apiGetPaymentMethod(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/payments", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiSubmitPayment(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/payments",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiFinishPayment(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/confirm_payment",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetOrderDetail(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/checkout",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiDirectOrder(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/direct_orders",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiUpdateOrderDetail(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/update",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiEstimateOrder(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/estimate",
    {
      ...params,
      his: {
        p: LocalStorage.getLastProducts(),
        s: LocalStorage.getLastStores(),
        c: LocalStorage.getLastCategories(),
      },
    },
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetBillingAddress(uid, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/addresses?uid=" + uid,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetSummary(orderCode, params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/orders/" + orderCode, params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetPriceTags(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/price_tags",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
    false,
    true,
  );
}

export function apiGetPriceSavings(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/checkout/detail_prices",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetOrderHistory(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/orders/", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiTrackingOrder(orderNo, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + `/v1/orders/${orderNo}/track`,
    undefined,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}


export function apiCancelOrder(orderCode, params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/orders/" + orderCode + "/cancel",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetTicket(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/tickets/", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiCreateTicket(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/tickets",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiSubscribe(onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/subscribe",
    undefined,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetSiteInfo(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/sites/", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiSearchCategory(params, onSuccess, onError, apiTime) {
  let headers = genHeaderApi();
  if (params?.locale) {
    headers['App-Locale'] = params.locale;
    delete params.locale;
  }

  return callApi(
    endPointDutycastB2C + "/v1/search/category",
    {
      ...params,
      his: {
        p: LocalStorage.getLastProducts(),
        s: LocalStorage.getLastStores(),
        c: LocalStorage.getLastCategories(),
      },
    },
    "POST", headers, function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}


export function apiSearchSite(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/search/site",
    {
      ...params,
      his: {
        p: LocalStorage.getLastProducts(),
        s: LocalStorage.getLastStores(),
        c: LocalStorage.getLastCategories(),
      },
    },
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetTrustedParters(onSuccess, onError, apiTime) {
  return callApi(
    Env.DUTY_CAST_EXTENSION_API_TRUSTED_PARTNERS,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
    false,
    true,
  );
}

export function apiGetInThePress(onSuccess, onError, apiTime) {
  return callApi(
    Env.DUTY_CAST_EXTENSION_API_IN_THE_PRESS,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
    false,
    true,
  );
}

export function apiGetLocationOffice(onSuccess, onError, apiTime) {
  return callApi(
    Env.DUTY_CAST_EXTENSION_API_OFFICES,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
    false,
    true,
  );
}

export function apiGetFaqList(params, onSuccess, onError, apiTime) {
  return window.hsSearch = callApi(
    genEndPointGetParam(endPointSearchDutycastB2C + "/v5/search"),
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiTracking(param = {}, body = {}, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(Env.DUTY_CAST_EXTENSION_PUBLIC_TRACK_URL, param),
    { ...param, url: window.location.href, ...body },
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        // console.error(error);
      }
    }
  ).catch(() => { });;
}

export function apiGetDirectCheckoutLink(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/orders/share/",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetIpConfig(onSuccess, onError, apiTime) {
  const headers = genHeaderApi();
  if (!LocalStorage.getIpCountry()) {
    delete headers["App-Locale"];
  }
  return callApi(
    endPointDutycastB2C + "/v1/ipconfig",
    undefined,
    "GET", headers, function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiUpdateSetting(onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/settings/",
    undefined,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetBannerOntop(onSuccess, onError, apiTime) {
  return callApi(
    Env.DUTY_CAST_EXTENSION_API_BANNER_ON_TOP,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
    false,
    true,
  );
}

export function apiGetBannerSlider(onSuccess, onError, apiTime) {
  return callApi(
    Env.DUTY_CAST_EXTENSION_API_BANNER_SLIDER,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
    false,
    true,
  );
}

export function apiGetProductLDP(slug, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/lp/" + slug,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetBannerCategoryLDP(onSuccess, onError, apiTime) {
  return callApi(
    Env.DUTY_CAST_EXTENSION_API_BANNER_CATEGORY,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
    false,
    true,
  );
}

export function apiGetShortLink(slug, productId, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/short_links/" + slug, {
      product_id: productId,
    }),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiCreateShortLink(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/short_links/",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetPromotions(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/promotions/", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetLPProductAds(onSuccess, onError, apiTime) {
  return callApi(
    Env.DUTY_CAST_EXTENSION_API_PRODUCT_ADS,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
    false,
    true,
  );
}

export function apiGetTestimonial(onSuccess, onError, apiTime) {
  return callApi(
    Env.DUTY_CAST_EXTENSION_API_TESTIMONIAL,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
    false,
    true,
  );
}

export function apiGetAuthProvider(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(Env.DUTY_CAST_EXTENSION_AUTH_PROVIDER, params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
    false,
  );
}

export function apiGetCollaboratorSummary(param = {}, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/collaborator/summary/", param),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetCollaboratorOrder(param = {}, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/collaborator/orders/", param),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetCollaboratorProducts(param = {}, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/collaborator/products/", param),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetCollaboratorProductsHistory(param = {}, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/collaborator/product_histories/", param),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetProductCategories(onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/categories",
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const result = Category.fromApiArray(data.data);
          typeof (onSuccess) === "function" && onSuccess(result);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetProductSearch(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/search",
    {
      ...params,
      his: {
        p: LocalStorage.getLastProducts(),
        s: LocalStorage.getLastStores(),
        c: LocalStorage.getLastCategories(),
      },
    },
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiSearchAutoComplete(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointSearchDutycastB2C + "/v5/autocomplete",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetProductDetail(id, params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/products/" + id, params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          typeof (onSuccess) === "function" && onSuccess(data);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetProductVariants(id, params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/products/" + id + "/variants", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          typeof (onSuccess) === "function" && onSuccess(data);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiEstimateProductPrice(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/estimate_price/",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          typeof (onSuccess) === "function" && onSuccess(data);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiEstimateProductPriceMultiple(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/estimate_price/multiple",
    {
      ...params,
      his: {
        p: LocalStorage.getLastProducts(),
        s: LocalStorage.getLastStores(),
        c: LocalStorage.getLastCategories(),
      },
    },
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          typeof (onSuccess) === "function" && onSuccess(data);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetProductPackage(id, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/categories", id),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          typeof (onSuccess) === "function" && onSuccess(data);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiCollaboratorCreateLink(body, onSuccess, onError, apiTime) {
  return callApi(endPointDutycastB2C + "/v1/collaborator/direct_orders",
    body,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        try {
          const url = getOr("", "data.url")(data);
          typeof (onSuccess) === "function" && onSuccess(url);
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiEstimatePrice(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/estimate_price/",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetAddressBook(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/me/addresses", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiCreateAddressBook(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/me/addresses",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiUpdateAddressBook(id, params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/me/addresses/" + id,
    params,
    "PUT", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiDeleteAddressBook(id, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/me/addresses/" + id,
    undefined,
    "DELETE", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetSalePopup(onSuccess, onError, apiTime) {
  return callApi(
    Env.DUTY_CAST_EXTENSION_API_SALE_DIALOG,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    },
    false,
    true,
  );
}

export function apiGetBankInformation(onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/me/bank_info",
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiUpdateBankInformation(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/me/bank_info",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiUploadAttachments(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/attachments",
    params,
    "POST", genHeaderApi(true), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }, true
  );
}

export function apiGetBankName(onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/banks",
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiRequestLogin(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/auth/login",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiSendConfirmation(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/auth/send_confirmation",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiConfirmAuth(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/auth/confirm",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetUserInfoFromReceiptSource(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/se/config", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiUpdateUserInfo(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/me/user_info",
    params,
    "PUT", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        const result = Auth.fromApiObject(data);
        typeof (onSuccess) === "function" && onSuccess(result);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiAddToCart(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/orders",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}


export function apiGetNotification(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/notification/messages", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiNotificationTracking(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/notification/trackings",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetUnreadNotification(onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/notification/unread_count",
    undefined,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiNotificationMarkRead(onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/notification/mark_read",
    undefined,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiCreateMerchantStore(params, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/merchant/stores",
    params,
    "POST", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}


export function apiGetMerchantStoreList(params, onSuccess, onError, apiTime) {
  return callApi(
    genEndPointGetParam(endPointDutycastB2C + "/v1/merchant/stores", params),
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}

export function apiGetMerchantStore(id, onSuccess, onError, apiTime) {
  return callApi(
    endPointDutycastB2C + "/v1/merchant/stores/" + id,
    undefined,
    "GET", genHeaderApi(), function (data) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onSuccess) === "function" && onSuccess(data);
      }
    }, function (error) {
      if (!apiTime || apiTime === window.apiTime) {
        typeof (onError) === "function" && onError(error);
        console.error(error);
      }
    }
  );
}